module.exports = "/1st/2026/packs/img_search_icon_a-07bb917bdae6693ccae6f46b4410dec7.png";